import { AdvancedTourStep } from '../shared-types';
import { ComponentTourProps } from './component-tour-props';

export function getTaskGeneralTourSteps({ defaultStyles }: ComponentTourProps): AdvancedTourStep[] {
	return [
		{
			id: 'task-type',
			selector: '[data-tour="task-type"]',
			content: 'A prepopulated dropdown displaying the task type added to the diagram',
		},
		{
			id: 'task-name',
			selector: '[data-tour="task-name"]',
			content:
				'A unique name for your task, the name needs to be unique across the flow, this is a required field and the task can not be made if it is not populated.',
		},
		{
			id: 'task-description',
			selector: '[data-tour="task-description"]',
			content:
				'Optional: You can provide a basic or in depth description of the goal and purpose of the task item.',
		},
		{
			id: 'task-date-created',
			selector: '[data-tour="task-date-created"]',
			content: 'The date at which the task was added to the flow.',
		},
		{
			id: 'task-date-updated',
			selector: '[data-tour="task-date-updated"]',
			content:
				'The date at which the task was last updated, this field updates automatically as changes are saved.',
		},
		{
			id: 'task-enabled',
			selector: '[data-tour="task-enabled"]',
			content:
				'A toggle to set whether the task should be active or inactive during the run cycle of a flow',
		},
		{
			id: 'task-color',
			selector: '[data-tour="task-color"]',
			content:
				'Set a color for the task to display for the flow, this gives the ability to easily identify your tasks, for example: tasks of the same category can be color coordinated.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
